<template>
    <vx-input v-bind="attrs" v-on="listeners" v-mask="appliedMask" v-model="medicareNumber" />
</template>

<script>
export default {
    name: 'vx-medicare-card-input',
    props: {
        value: {
            type: String
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            medicareNumberX: null,
            appliedMask: '',
            backupValue: -1
        }
    },
    watch: {
        value: {
            handler: function (newv, oldv) {
                // HACK: Must set the mask before the value, other v-mask forces the
                // old value to conform to the new mask and erases it
                if (this.backupValue != -1) {
                    if (this.backupValue == null || !newv) {
                        this.medicareNumber = this.backupValue
                    } else {
                        this.medicareNumber = newv
                    }
                    this.backupValue = -1
                } else {
                    var newMask = this.getMask(newv)

                    if (this.appliedMask !== newMask) {
                        if (newv || oldv) {
                            this.backupValue = newv
                        }
                        this.appliedMask = newMask
                    }
                }
            },
            immediate: true
        }
    },
    computed: {
        medicareNumber: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        listeners() {
            delete this.$listeners.input
            return this.$listeners
        },
        attrs() {
            return {
                name: 'medicare',
                icon: 'icon-credit-card',
                placeholder: '#### ##### ##',
                clearable: false,
                ...this.$attrs,
                rules: [...this.rules, 'medicare']
            }
        }
    },
    methods: {
        getMask(value) {
            if (!value) {
                return '#### ##### ##'
            }

            var trimmed = value.replace(/[^\d]/g, '')

            if (trimmed.length < 11) {
                trimmed = '0'.repeat(10 - trimmed.length) + trimmed
            } else if (trimmed.length > 10) {
                trimmed = trimmed.slice(0, 11)
            }

            return '#### ##### ##'
        }
    }
}
</script>

<style scoped></style>
